import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Alert,
  Card,
  CardContent
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';

const Step6View: React.FC = () => {
  const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();
  const [open, setOpen] = useState<boolean>(true);

  if (!formulario) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <Typography>Carregando informações...</Typography>
      </Box>
    );
  }

  return (
    <Paper elevation={1} sx={{ p: 0, mt: 2 }}>
      <Box
        sx={{ px: 3, pt: 2, cursor: 'pointer', userSelect: 'none' }}
        onClick={() => setOpen(!open)}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 500,
              color: "text.primary",
              mb: 1,
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            {open ? (
              <KeyboardArrowUpOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            ) : (
              <KeyboardArrowDownOutlined
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
            )}
            Quadro de Servidores
          </Typography>
        </Box>
        <Divider sx={{ mb: 1 }} />
      </Box>

      {open && (
        <Box sx={{ p: 3 }}>
          <Grid container spacing={3}>
            {/* Resumo Quantitativo */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                Resumo Quantitativo
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ backgroundColor: '#e3f2fd' }}>
                    <CardContent>
                      <Typography variant="h4" color="primary" align="center">
                        {formulario.quadro_servidores_secretaria_quantidade ?? '0'}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" align="center">
                        Total de Servidores
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Card variant="outlined" sx={{ backgroundColor: '#e8f5e8' }}>
                    <CardContent>
                      <Typography variant="h4" color="success" align="center">
                        {(formulario.quadro_servidores_secretaria_lista?.filter((s: any) =>
                          s.tipo_vinculo === 'Efetivo' || s.tipo_vinculo === 'Efetivo com cargo comissionado'
                        ).length ?? 0)}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" align="center">
                        Servidores Concursados
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            {/* Lista Detalhada de Servidores */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                Lista Detalhada de Servidores
              </Typography>

              {formulario.quadro_servidores_secretaria_lista &&
                formulario.quadro_servidores_secretaria_lista.length > 0 ? (
                <TableContainer component={Paper} variant="outlined">
                  <Table>
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell><strong>Nome</strong></TableCell>
                        <TableCell><strong>Tipo de Vínculo</strong></TableCell>
                        <TableCell><strong>Telefone</strong></TableCell>
                        <TableCell><strong>Email</strong></TableCell>
                        <TableCell><strong>Grau de Escolaridade</strong></TableCell>
                        <TableCell><strong>Ensino Médio/Técnico</strong></TableCell>
                        <TableCell><strong>Ensino Superior</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formulario.quadro_servidores_secretaria_lista.map((servidor, index) => (
                        <TableRow key={index}>
                          <TableCell>{servidor.nome || 'N/I'}</TableCell>
                          <TableCell>{servidor.tipo_vinculo || 'N/I'}</TableCell>
                          <TableCell>{servidor.telefone || 'N/I'}</TableCell>
                          <TableCell>{servidor.email || 'N/I'}</TableCell>
                          <TableCell>
                            {servidor.grau_escolaridade || 'N/I'}
                          </TableCell>
                          <TableCell>
                            {servidor.grau_escolaridade === 'Médio técnico' ? (servidor.medio_tecnico_concluido || 'N/I') : ''}
                          </TableCell>
                          <TableCell>
                            {(servidor.grau_escolaridade === 'Superior' || servidor.grau_escolaridade === 'Pós-graduado') ? (servidor.superior_concluido || 'N/I') : ''}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Alert severity="info">
                  <Typography variant="body2">
                    Nenhum servidor foi cadastrado na lista detalhada.
                  </Typography>
                </Alert>
              )}
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
};

export default Step6View;
